// Captures ?mkt_campaign / ?mkt_ref query params from marketing email links so
// orders placed shortly after can be attributed for the admin revenue stats.
const STORAGE_KEY = 'kostin_mkt_attribution';

export const captureMarketingAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  const campaign = params.get('mkt_campaign');
  const ref = params.get('mkt_ref');
  if (campaign) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ campaign, ref: ref || null }));
  }
};

export const getMarketingAttribution = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearMarketingAttribution = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
